import { render } from "./CheckboxGroupField.vue?vue&type=template&id=4dcb0c5f"
import script from "./CheckboxGroupField.vue?vue&type=script&lang=js"
export * from "./CheckboxGroupField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__